export function median(list) {
    list = [... list];
    list.sort();
    return list[Math.floor(list.length / 2)];
}
